import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "pa-2",
  style: {"width":"50%"}
}

import { AssetManagementPlan } from "@/classes";
import RichText from "@/components/base/inputs/RichText.vue";
import LinkTable from "../links/LinkTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DiffAssetInformation',
  props: {
    plan: {},
    diffPlan: {},
    diff: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RichText, {
      class: "mb-4",
      "model-value": _ctx.plan?.ownership_responsibility ?? '',
      "diff-value": _ctx.diffPlan?.ownership_responsibility,
      label: "4.1 Ownership & Responsibility",
      readonly: "",
      options: { diff: _ctx.diff }
    }, null, 8, ["model-value", "diff-value", "options"]),
    _createVNode(RichText, {
      class: "mb-4",
      "model-value": _ctx.plan?.asset_class_description ?? '',
      "diff-value": _ctx.diffPlan?.asset_class_description,
      label: "4.2 Asset Class & Description",
      readonly: "",
      options: { diff: _ctx.diff }
    }, null, 8, ["model-value", "diff-value", "options"]),
    _createVNode(RichText, {
      class: "mb-4",
      "model-value": _ctx.plan?.selection_procurement ?? '',
      "diff-value": _ctx.diffPlan?.selection_procurement,
      label: "4.3 Selection & Procurement",
      readonly: "",
      options: { diff: _ctx.diff }
    }, null, 8, ["model-value", "diff-value", "options"]),
    _createVNode(RichText, {
      class: "mb-4",
      "model-value": _ctx.plan?.risk_register ?? '',
      "diff-value": _ctx.diffPlan?.risk_register,
      label: "4.4 Risk Register",
      readonly: "",
      options: { diff: _ctx.diff }
    }, null, 8, ["model-value", "diff-value", "options"]),
    _createVNode(LinkTable, {
      class: "mb-4",
      label: "4.4.1 Risk Register Links",
      links: _ctx.plan?.risk_register_links ?? [],
      readonly: ""
    }, null, 8, ["links"])
  ]))
}
}

})